if (!customElements.get('product-add-to-cart-sticky')) {
class ProductAddToCartSticky extends HTMLElement {
    constructor() {
        super();
        this.handleVariantChange = this.handleVariantChange.bind(this);
        this.handleTargetIntersect = this.handleTargetIntersect.bind(this);
        this.syncInertState = this.syncInertState.bind(this);
        this.sectionId = this.dataset.section;
    }

    connectedCallback() {
        this.targetElement = document.querySelector('[id^="ProductSubmitButton-"]');
        this.stickyAtcVariantInput = this.querySelector('.product-variant-id');

        if (this.targetElement) {
            this.targetObserver = new IntersectionObserver(this.handleTargetIntersect);
            this.targetObserver.observe(this.targetElement);
        }
        document.body.addEventListener('change', this.handleVariantChange);
        this.observeCartOverlays();
    }

    disconnectedCallback() {
        if (this.targetObserver) this.targetObserver.disconnect();
        if (this.cartOverlayObserver) this.cartOverlayObserver.disconnect();
        document.body.removeEventListener('change', this.handleVariantChange);
    }

    // The cart drawer/notification overlay already paints over the sticky
    // bar (its z-index is higher), but that alone doesn't stop a keyboard
    // user from tabbing to the still-visible-through-overlay button and
    // submitting it. `inert` removes it from the a11y tree, tab order and
    // pointer events for as long as the drawer/notification stays open.
    observeCartOverlays() {
        this.cartOverlays = [document.querySelector('cart-drawer'), document.getElementById('cart-notification')].filter(
            Boolean
        );
        if (this.cartOverlays.length === 0) return;

        this.cartOverlayObserver = new MutationObserver(this.syncInertState);
        this.cartOverlays.forEach((overlay) =>
            this.cartOverlayObserver.observe(overlay, { attributes: true, attributeFilter: ['class'] })
        );
        this.syncInertState();
    }

    syncInertState() {
        this.inert = this.cartOverlays.some((overlay) => overlay.classList.contains('active'));
    }

    handleTargetIntersect([entry]) {
        // Show the sticky bar once the original add-to-cart button has scrolled
        // past the top of the viewport (boundingClientRect.top < 0); keep it
        // hidden while the button is visible or hasn't been reached yet.
        const isScrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.classList.toggle('show', isScrolledPast);
    }

    updateStickyATCOption(optionName, optionValue) {
        const matches = optionName.match(/options\[(.+)\]/);
        if (matches && matches[1]) {
            optionName = matches[1];
        }

        const optionDisplay = this.querySelector('.selected-variant-option[data-option-name="' + optionName + '"]');
        if (optionDisplay) {
            optionDisplay.textContent = optionName + ': ' + optionValue;
        }
    }

    handleVariantChange(event) {
        const target = event.target;
        const productSection = target.closest(`#MainProduct-${this.sectionId}`);
        if (!productSection) return;
        if (target.tagName === 'INPUT' || target.tagName === 'SELECT') {
            const optionName = target.name;
            const optionValue = target.tagName === 'INPUT' ? target.value : target.options[target.selectedIndex].textContent;
            this.updateStickyATCOption(optionName, optionValue);
        }
    }
}

customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}
